import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { clearUserAuthenticated, isUserAuthenticated } from '../../helpers/authSession';
import { revokeTechnicalSession } from '../../services/rulesEngineSession';
import { getVisibleMenuItems, isMenuItemSelectedByPath, routePaths } from 'config/navigation';

export default function MenuContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasSession = isUserAuthenticated();
  const visibleMenuItems = getVisibleMenuItems();
  const iconByKey = {
    dashboard: <DashboardRoundedIcon />,
    transactions: <AnalyticsRoundedIcon />,
    clientRules: <GavelRoundedIcon />,
    adminPlans: <Inventory2RoundedIcon />,
    policyGovernance: <AccountTreeRoundedIcon />,
    adminTenancy: <ApartmentRoundedIcon />,
  };

  const handleListItemClick = (path) => {
    navigate(path);
  };

  const handleLogout = async () => {
    await revokeTechnicalSession();
    clearUserAuthenticated();
    navigate(routePaths.login);
  };

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {visibleMenuItems.map((item) => (
          <ListItem key={item.path} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              selected={isMenuItemSelectedByPath(location.pathname, item)}
              onClick={() => handleListItemClick(item.path)}
            >
              <ListItemIcon>{iconByKey[item.key]}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      {hasSession && (
        <List dense>
          <ListItem disablePadding sx={{ display: 'block' }}>
            <ListItemButton onClick={handleLogout}>
              <ListItemIcon>
                <LogoutRoundedIcon />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItemButton>
          </ListItem>
        </List>
      )}
    </Stack>
  );
}
